// The global loader counter
import { types } from "../actions";

export default (state = 0, { type }) => {
  switch (type) {
    case types.INCREASE_LOADING_COUNTER: {
      return ++state;
    }
    case types.DECREASE_LOADING_COUNTER: {
      // The counter has to be >= 0
      return state > 0 ? --state : 0;
    }
    default: {
      return state;
    }
  }
};
